import React from 'react'
import { PrismicRichText } from '@prismicio/react'
import Card from './card'

const CardDeck = ({ slice }) => {
  var numberOfCards = slice.items.length
  var gridClass = ''
  if (numberOfCards > 4) {
    gridClass = 'md:grid-cols-4'
  } else if (numberOfCards === 4) {
    gridClass = 'md:grid-cols-2 lg:grid-cols-4'
  } else {
    gridClass = 'md:grid-cols-' + numberOfCards
  }
  return (
    <section className='component-card_deck mx-auto max-w-screen-xl p-6'>
      <div className='py-5 md:pb-10'>
        <div className='prose prose-lg mb-10 min-w-full text-center'>
          <PrismicRichText field={slice.primary.deck_title.richText} />
        </div>
        <ul className={`grid grid-cols-1 gap-8 ${gridClass}`}>
          {slice.items.map((card, index) => {
            return <Card fields={card} key={`card-${index}`} />
          })}
        </ul>
      </div>
    </section>
  )
}

export default CardDeck
